import HybridTeaserContext from '@contexts/hybridTeaser'
import { useContext } from 'react'

const useIsHybridTeaser = (): boolean => !!useContext(HybridTeaserContext)

export default useIsHybridTeaser
